module.exports = "//static.hsappstatic.net/ComposeUI/static-1.9550/img/share@2x.png"